import React from 'react';
import Helmet from 'react-helmet';
import SEO from '../../../../components/SEO';
import '../../../../scss/pages/workplace-2020.scss';
import Layout from '../../../../layouts/index';
import HtmlParser from 'html-react-parser';
import { Link } from 'react-scroll';
import { DemoFormShortPDF } from '../../../../components/DemoFormShortPDF.jsx';
import { DemoFormLong } from '../../../../components/DemoFormLong.jsx';

const Home = (props) => {
	
	const location = props.location;

	return (
		<Layout bodyClass="workplaces" ontouchstart>
			<SEO title="Charting Better Workplaces: 2020 Report | ChartHop" />
			<Helmet>
				<meta name="description" content="This annual report provides comprehensive data on compensation equity in the tech industry. We believe this data is the next step towards closing the wage gap."/>
				<meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
				<meta property="og:title" content="Charting Better Workplaces: 2020 Report | ChartHop" />
				<meta property="og:description" content="This annual report provides comprehensive data on compensation equity in the tech industry. We believe this data is the next step towards closing the wage gap." />
				<meta property="og:image" content={`https://www.charthop.com/data-report/meta-fn-b.png`} />
				<meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="Charting Better Workplaces: 2020 Report | ChartHop" />
				<meta name="twitter:description" content="This annual report provides comprehensive data on compensation equity in the tech industry. We believe this data is the next step towards closing the wage gap." />
				<meta name="twitter:image" content={`https://www.charthop.com/data-report/meta-fn-b.png`} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
			</Helmet>

			{/* HEADER */}
			<section className="intro sectionSpacing pb-md-3">
				<div className="container hero-formNoImage">
					<div class="introContent">
						<div className="introTitle heroTopContent mb-2">
							<h2 className="heroTitle">Charting Better Workplaces:</h2>	
							<h1 className="heroSubTitle">2020 Report</h1>
						</div>							
							<DemoFormShortPDF CBW pdfUrl={'/data-report/ChartHop-Compensation-Data-Report-2020.pdf'} source={"resources-charting-better-workplaces-2020-PDF-contentdownload-header"}/> 
						<div> 
							<Link to="keyFindings" smooth={true} offset={-70} duration={500}><div class="arrow bounce"></div></Link>
						</div>
					</div>
				</div>		
			</section>

			{/* SUB NAVBAR */}
			<section className="subNavigationMenu-workplace backgroundGradientContainer">
				<div className="container">	
				<div className="navigation-element">
							<Link to="keyFindings" smooth={true} offset={-70} duration={500}>Key Findings</Link>
						</div>
						<div className="separator sep1">|</div>				
						<div className="navigation-element">
							<Link to="introductionSection" smooth={true} offset={-70} duration={500}>Introduction</Link>
						</div>
						<div className="separator sep2">|</div>
						<div className="navigation-element">
							<Link to="womenWagesSection" smooth={true} offset={-70} duration={500}>Women's Wages<br></br>Remain an Issue</Link>
						</div>
						<div className="separator sep3">|</div>
						<div className="navigation-element">
							<Link to="senioritySection" smooth={true} offset={-70} duration={500}>The Role of Seniority</Link>
						</div>
						<div className="separator sep4">|</div>                    
                        <div className="navigation-element">
							<Link to="racesWagesSection" smooth={true} offset={-70} duration={500}>Wages Across Race<br></br>Lag in Progress</Link>
						</div>
						<div className="separator sep5">|</div>
						<div className="navigation-element">
							<Link to="wageGapDepartmentSection" smooth={true} offset={-70} duration={500}>Wage Gaps by<br></br>Department</Link>
						</div>
						<div className="separator sep6">|</div>
						<div className="navigation-element">
							<Link to="conclusionSection1" smooth={true} offset={-70} duration={500}>Conclusion</Link>
						</div>	
				</div>
			</section>

			{/*KEY FINDINGS*/}
			<section className="keyFindings sectionSpacing">
				<div className="container">
					<h2 class="text-center mb-lg-4 mb-3">Key Findings</h2>
					<div className="row">
						<div className="col-lg-12 row keyFindingsBox">
							<div className="keyFindingBullet col-xl-2 col-lg-1 col-md-2 col-12"> 
								<img src={'/data-report/key-findings1.svg'} alt="checkmark"></img>
							</div>
							<div className="keyFindingText col-xl-10 col-lg-11 col-md-10 col-12">
								<h4>While the gender wage gap still exists, progress is being made.</h4>
								<p>Men earned <span className="blueBold">22%</span> more than women in 2020, compared to <span className="blueBold">30%</span> more in 2018.<a class="super" href="https://twitter.com/share?text=%22While%20the%20gender%20wage%20gap%20still%20exists,%20progress%20is%20being%20made.%22%20%40ChartHop%C2%A0&amp;url=https://charthop.com/charting-better-workplaces/2020/&amp;hashtags=ChartingBetterWorkplaces" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img></a></p> 
							</div>							
						</div>
						<div className="col-lg-12 row keyFindingsBox">
							<div className="keyFindingBullet col-xl-2 col-lg-1 col-md-2 col-12"> 
								<img src={'/data-report/key-findings2.svg'} alt="checkmark"></img>
							</div>
							<div className="keyFindingText col-xl-10 col-lg-11 col-md-10 col-12">
								<h4>There is a gap in equity ownership, the biggest driver of wealth in tech.</h4>
								<p>On average, men have <span className="blueBold">63%</span> more ownership in a company than women.<br></br>
								Women make up <span className="blueBold">40%</span> of owners yet only own <span className="blueBold">21%</span> of the shares.<a class="super" href="https://twitter.com/share?text=%22There%20is%20a%20gap%20in%20equity%20ownership,%20the%20biggest%20driver%20of%20wealth%20in%20tech.%22%%20%40ChartHopC2%A0&amp;url=https://charthop.com/charting-better-workplaces/2020/&amp;hashtags=ChartingBetterWorkplaces" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img></a></p> 
							</div>
						</div>
						<div className="col-lg-12 row keyFindingsBox">
							<div className="keyFindingBullet col-xl-2 col-lg-1 col-md-2 col-12">
								<img src={'/data-report/key-findings3.svg'} alt="checkmark"></img>
							</div>
							<div className="keyFindingText col-xl-10 col-lg-11 col-md-10 col-12">
								<h4>Seniority is not driving the wage gap as much as we thought.</h4>
								<p>Men who are individual contributors still earn <span className="blueBold">22%</span> more than women.<a class="super" href="https://twitter.com/share?text=%22Seniority%20is%20not%20driving%20the%20wage%20gap%20as%20much%20as%20we%20thought.%22%20%40ChartHop%C2%A0&amp;url=https://charthop.com/charting-better-workplaces/2020/&amp;hashtags=ChartingBetterWorkplaces" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img></a></p>   
							</div>
						</div>
						<div className="col-lg-12 row keyFindingsBox">
							<div className="keyFindingBullet col-xl-2 col-lg-1 col-md-2 col-12">
								<img src={'/data-report/key-findings4.svg'} alt="checkmark"></img>
							</div>
							<div className="keyFindingText col-xl-10 col-lg-11 col-md-10 col-12">
								<h4>The gap between Black and White employees is double the gap between men and women.</h4>
								<p>White employees earn <span className="blueBold">44%</span> more than their Black counterparts.<a class="super" href="https://twitter.com/share?text=%22The%20gap%20between%20Black%20and%20White%20employees%20is%20double%20the%20gap%20between%20men%20and%20women.%22%20%40ChartHop%C2%A0&amp;url=https://charthop.com/charting-better-workplaces/2020/&amp;hashtags=ChartingBetterWorkplaces" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img></a></p> 
							</div>
						</div>
						<div className="col-lg-12 row keyFindingsBox">
							<div className="keyFindingBullet col-xl-2 col-lg-1 col-md-2 col-12">
								<img src={'/data-report/key-findings5.svg'} alt="checkmark"></img>
							</div>
							<div className="keyFindingText col-xl-10 col-lg-11 col-md-10 col-12">
								<h4>The pay gap for BIPOC (Black, Indigenous and People of Color) is increasing.</h4>
								<p>White employees earn <span className="blueBold">24%</span> more than their BIPOC colleagues. This is up <span className="blueBold">6 percentage</span> points in 2020.<a class="super" href="https://twitter.com/share?text=%22The%20pay%20gap%20for%20BIPOC%20(Black,%20Indigenous%20and%20People%20of%20Color)%20is%20increasing.%22%20%40ChartHop%C2%A0&amp;url=https://charthop.com/charting-better-workplaces/2020" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img></a></p> 
							</div>
						</div>
						<div className="col-lg-12 row keyFindingsBox">
							<div className="keyFindingBullet col-xl-2 col-lg-1 col-md-2 col-12">
								<img src={'/data-report/key-findings6.svg'} alt="checkmark"></img>
							</div>
							<div className="keyFindingText col-xl-10 col-lg-11 col-md-10 col-12">
								<h4>Engineering teams have made big improvements.</h4>
								<p>The average man in engineering earns <span className="blueBold">7%</span> more than the average woman.<a class="super" href="https://twitter.com/share?text=%22Engineering%20teams%20have%20made%20big%20improvements%20in%20closing%20the%20gender%20wage%20gap.%22%20%40ChartHop%C2%A0&amp;url=https://charthop.com/charting-better-workplaces/2020/&amp;hashtags=ChartingBetterWorkplaces" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img></a></p> 
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* INTRODUCTION */}
			<section className="introductionSection backgroundGradientContainer sectionSpacing">
				<div className="container">
					<h2 className="text-center">Introduction</h2>							
					<div className="introductionContentBox row align-items-center">
						<div className="leftBox col-lg-4 col-12">
							<h4>We believe data drives action.</h4>				
							<p>We also believe that to build a better, more equitable future, all of us need to know where we stand. </p>							
							<p>Given the ongoing conversations about gender and racial inequities in our industry, this is more important than ever.</p>

						
						</div>
						<div className="rightBox col-lg-8 col-12">
							<p>In our first annual <span className="blue">Charting Better Workplaces</span> report, our goal is to shine a light on the tech industry’s wage gap. Information inspires action, and wage inequality is a solvable problem. </p>
							<p>Companies use ChartHop to manage their orgs and people data, giving ChartHop unprecedented access to real&#8209;time salary, equity, demographic and organizational structure data. For this report, we aggregated and anonymized the data of more than 16,000 employees from private and public tech companies.</p>
							<p>Unlike <span className="blue">Charting Better Workplaces</span>, most existing reports are built off of self&#8209;reported and/or assumed data, focus on one part of compensation, or don't speak to organizational data at all. We're excited to share this report as a new perspective on wage gap data. </p>
						
							<h4 className="introductionCopy">Let's use this data to chart a course toward better, more equitable workplaces.</h4>
						</div>
					</div> 					
									
					<div className="introductionSecondContentBox row">
						<div className="leftBoxSecondRow col-lg-2 col-md-3 col-12">
						<h4 className="leftBoxTitle">A Note on Non&#8209;binary Data</h4>
						</div>
						<div className="rightBoxSecondRow col-lg-10 col-md-9 col-12">
							<p>Reporting in a gender&#8209;binary framework does not give us the whole picture and contributes to sustained inequality.</p> <p>Unfortunately, many Human Resource Information Systems (HRIS) do not have an option for Non&#8209;binary designations. We are actively working with partners and customers to address this issue.</p>
							<p>For now, we can say that the number of Non&#8209;binary employees has increased, and the salaries of Non&#8209;binary persons are closer to women than men.</p>
							<p>
							Our goal is to have better defined Non&#8209;binary data included in future reports.</p>
						</div>
					</div> 	
				</div>
			</section>

			{/* GET REPORT BOX */}
			<section className="getReport-box sectionSpacing">				
				<div class="container" id="getReport">
					<div class="row">
						<div class="col-md-6 col-12">
							<p class="getReport--main--text">Download the full report</p>
							<p class="getReport--secondary--text">and get more insights as they become available.</p>
						</div>
						<div class="col-md-6 col-12">							
							<DemoFormShortPDF CBW pdfUrl={'/data-report/ChartHop-Compensation-Data-Report-2020.pdf'} source={"resources-charting-better-workplaces-2020-PDF-contentdownload-box1"}/> 							
						</div>
					</div> 
				</div>				
			</section>

			{/* WOMEN WAGES */}
			<section className="womenWagesSection sectionSpacing">
				<div className="container">
					<h2 className="text-center mb-lg-3 mb-2">Women’s Wages Remain an Issue</h2>		
					<div className="row align-items-center mb-5">
						<div className="col-md-6 col-12 pr-md-2 mb-md-0 mb-3">
							<p>It is no secret that there's a gender wage gap.</p>
							<p>When it comes to salary-based compensation, we found that the gap is decreasing. In 2020, men earn <span className="blueBold">22%</span> more than women, compared to <span className="blueBold">30%</span> in 2018.  
							</p>
							<p>Furthermore, women’s representation in the tech industry has remained constant since 2018 at <span className="blueBold">44%</span>, while:
								<ul>
									<li className="mt-1">In 2018, women only took home <span className="blueBold">27%</span> of the compensation,</li>
									<li> In 2019, that number grew to <span className="blueBold">31%</span>,</li>
									<li> In 2020, it's now at <span className="blueBold">33%</span>.</li>
								</ul>
							</p>
							<p>Although women are still taking home compensation that is disproportionate to their representation in the industry, it’s encouraging to see these numbers increase.</p>	
						</div>
						<div className="col-md-6 col-12 pl-md-2">
							<div className="graphBox">
								<h4 className="graphicHeading">WOMEN’S SHARE OF COMPENSATION VS. WORKFORCE OVER TIME</h4>
								<img src={'/data-report/graph-2.svg'} alt="graph-2"></img>
							</div>
						</div>
					</div> 
					<div className="row align-items-center mb-5">
						<div className="col-md-6 col-12 pr-md-2 mb-md-0 mb-2">
							<h4 className="leftBoxTitle greyBox">While we have a long way to go to close the wage gap, progress is being made.<a class="super" href="https://twitter.com/share?text=%22While%20we%20have%20a%20long%20way%20to%20go%20to%20close%20the%20wage%20gap,%20progress%20is%20being%20made.%22%20%40ChartHop%C2%A0&amp;url=https://charthop.com/charting-better-workplaces/2020/&amp;hashtags=ChartingBetterWorkplaces" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img></a></h4>
						</div>
						<div className="col-md-6 col-12 pl-md-2">
							<p>Inequalities between men and women in tech are also seen in the distribution of equity, one of the biggest drivers of wealth in this industry:
								<ul>
									<li className="mt-1">Men have <span className="blueBold">63%</span> more ownership in a company than women.</li>
									<li>Women make up <span className="blueBold">40%</span> of owners yet only own <span className="blueBold">21%</span> of the shares.</li> 
								</ul>
							</p>
							<p>Equity distribution changes significantly as companies mature, and lack of diversity in early teams contributes widely to these gaps.</p>
						</div>
					</div> 
					<div className="row graphBox">
						<div className="col-md-6 col-12 pr-md-2 mb-md-0 mb-6">
						<h4 className="graphicHeading mb-md-3 mb-0">MEN’S VS. WOMEN’S <span className="jump"><br></br></span>SALARIES YOY</h4>	
								
							<img src={'/data-report/graph-3.svg'} alt="graph-1"></img>
						</div>
						<div className="col-md-6 col-12 pl-md-2">
						<h4 className="graphicHeading">EQUITY DISTRIBUTION BETWEEN MEN AND WOMEN</h4>	
							<img src={'/data-report/graph-1.svg'} alt="graph-2"></img>		
						</div>
					</div> 
				</div> 
			</section>

			{/* SENIORITY */}
			<section className="senioritySection sectionSpacing backgroundGradientContainer">
				<div className="container">
					<h2 className="text-center mb-lg-3 mb-2">The Role of Seniority</h2>	
					<p>A commonly cited explanation for the existing gender wage gap is that women are less represented in higher paying leadership positions. While we found this to be true -- according to our data, <span className="blueBold">61%</span> of managers and <span className="blueBold">71%</span> of executives are men -- it doesn’t tell the full story. </p>
					<br></br>
					<div className="graphBox mb-lg-5 mb-4"> 
						<div className="row">
							<div className="col-12">
								<h4 className="text-center graphicHeading">MEN’S VS. WOMEN’S REPRESENTATION IN MANAGERIAL/<span className="jump"> </span>EXECUTIVE POSITIONS</h4>
							</div>
							<div className="col-md-4 col-12 pr-md-2 mb-md-0 mb-6 mx-auto text-center">
								<img className="pieGraph" src={'/data-report/graph-4-1.svg'} alt="graph-4-1"></img>
							</div>
							<div className="col-md-4 col-12 pr-md-2 mb-md-0 mb-6 mx-auto text-center">
								<img className="pieGraph" src={'/data-report/graph-4-2.svg'} alt="graph-4-2"></img>
							</div>
							<div className="col-md-4 col-12 pr-md-2 mx-auto text-center">
								<img className="pieGraph" src={'/data-report/graph-4-3.svg'} alt="graph-4-3"></img>
							</div>
						</div>	
					</div>							
					<div className="row mb-lg-4 mb-3">
						<div className="col-12 two-columns">
							<p>We tested this theory with our organizational structure data and found that the wage gap is <u>identical</u> among individual contributors, <span className="blueBold">22%</span>.</p>											
							<p>We also found that, while the lack of equal representation in leadership roles is alarming, progress is made when looking at managers and up. Managers who are men make <span className="blueBold">16%</span> more than women.</p>	
						</div>
					</div> 
					<div className="graphBox mb-4">	
						<h4 className="text-center graphicHeading">INDIVIDUAL CONTRIBUTOR & MANAGER SALARIES BY GENDER</h4>
						<img src={'/data-report/graph-5.svg'} alt="graph-5"></img>
					</div>	
				</div> 
			</section>

			{/* GET REPORT BOX */}
			<section className="getReport-box sectionSpacing">				
				<div class="container" id="getReport">
					<div class="row">
						<div class="col-md-6 col-12">
							<p class="getReport--main--text">Download the full report</p>
							<p class="getReport--secondary--text">and get more insights as they become available.</p>
						</div>
						<div class="col-md-6 col-12">							
							<DemoFormShortPDF CBW pdfUrl={'/data-report/ChartHop-Compensation-Data-Report-2020.pdf'} source={"resources-charting-better-workplaces-2020-PDF-contentdownload-box2"}/>
						</div>
					</div> 
				</div>				
			</section>	

			{/* RACES WAGES */}
			<section className="racesWagesSection sectionSpacing">
				<div className="container">
					<h2 className="text-center mb-lg-4 mb-3">Wages Across Race Lag in Progress</h2>
					<div className="row align-items-center mb-md-6 mb-3">
						<div className="col-md-6 col-12 pr-md-2 mb-md-0 mb-3">
							<div className="graphBox">
								<h4 className="graphicHeading">SALARIES BY RACE</h4>
								<img src={'/data-report/graph-6.svg'} alt="graph-6"></img>
							</div>
						</div>
						<div className="col-md-6 col-12 pl-md-2">
							<p>Our data also reveals stark inequalities in compensation and representation across race.</p>
							<h4 className="mb-lg-3 mb-2">In fact, the wage gap between Black and White employees is double the wage gap between men and women.<a class="super" href="https://twitter.com/share?text=%22In%20fact%2C%20the%20wage%20gap%20between%20Black%20and%20White%20employees%20is%20double%20the%20wage%20gap%20between%20men%20and%20women.%22%20%40ChartHop%C2%A0&amp;url=https://charthop.com/charting-better-workplaces/2020/&amp;hashtags=ChartingBetterWorkplaces" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img></a></h4>					
							<p>The average salary for a White employee in 2020 is $130,418.
							This is:
							<ul>
								<li className="mt-1"><span className="blueBold">44%</span> more than Black employees,</li>
								<li><span className="blueBold">33%</span> more than Hispanic employees,</li>
								<li><span className="blueBold"> 2%</span> more than Asian employees.</li> 
							</ul>
							</p> 
						</div>
					</div>

					<div className="row align-items-center mb-lg-6 mb-4">
						<div className="col-md-6 col-12 pr-md-2 mb-md-0 mb-3">
							<h4 className="mb-lg-3 mb-2">Although numbers remain low, representation of Black and Hispanic employees has increased.<a class="super" href="https://twitter.com/share?text=%22Although%20numbers%20remain%20low%2C%20representation%20of%20Black%20and%20Hispanic%20employees%20has%20increased.%22%20%40ChartHop%C2%A0&amp;url=https://charthop.com/charting-better-workplaces/2020/&amp;hashtags=ChartingBetterWorkplaces" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img></a></h4>							
							<p>In 2018, Black employees made up <span className="blueBold">4%</span> of this sample’s workforce and Hispanic employees made up <span className="blueBold">5%</span>. Those numbers have both increased to <span className="blueBold">8%</span> in 2020.</p>
							<p>Yet, both Black and Hispanic employees only take home <span className="blueBold">6%</span> of the compensation. Conversely, white employees make up <span className="blueBold">61%</span> of this workforce and take home <span className="blueBold">65%</span> of the compensation.</p>
						</div>
						<div className="col-md-6 col-12 pl-md-2">
							<div className="graphBox">
								<h4 className="graphicHeading">SHARE OF WORKFORCE VS. COMPENSATION BY RACE</h4>
								<img src={'/data-report/graph-7.svg'} alt="graph-7"></img>
							</div>
						</div>
					</div>

					<div className="row align-items-center">
						<div className="col-md-6 col-12 pr-md-2 mb-md-0 mb-3">
							<div className="blueBox">
								<h4>Interestingly, the wage gap has gotten bigger when you look at race as a whole.
								</h4> 
								<br></br>
								<h4> 
								In 2020, White employees earn <b>24%</b> more than their BIPOC (Black, Indigenous and People of Color) counterparts. This is up <b>6 percentage</b> points since 2019.
								</h4>
							</div>
						</div>
						<div className="col-md-6 col-12 pl-md-2">
							<p>It's alarming that during a time of an ongoing racial justice movement, the BIPOC wage gap is the only percentage from our report that is getting worse.</p>
							<p>As an industry, we need to put significant time and effort into addressing this increase to continue making progress towards a more equitable workforce.</p>
						</div>
					</div>

				</div> 
			</section>

			{/* WAGE GAP DEPARTMENT */}
			<section className="wageGapDepartmentSection sectionSpacing backgroundGradientContainer ">
				<div className="container">
					<h2 className="text-center mb-lg-4 mb-3">Wage Gaps by Department:<br></br> Engineering Shows Progress While Sales Teams Have Work to Do</h2>
					<div className="row mb-lg-5 mb-3">
						<div className="col-12">
							<p>The engineering gender wage gap in 2020 is <span className="blueBold"> 7%</span>, which is significantly smaller than the overall average of <span className="blueBold"> 22%</span>. <a class="super" href="https://twitter.com/share?text=%22The%20engineering%20gender%20wage%20gap%20in%202020%20is%207%25%2C%20which%20is%20significantly%20smaller%20than%20the%20overall%20average%20of%2022%25.%20%22%%20%40ChartHopC2%A0&amp;url=https://charthop.com/charting-better-workplaces/2020/&amp;hashtags=ChartingBetterWorkplaces" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img></a></p><p>
								</p>
								<p>Engineering teams, typically dominated by men, have received a bad rap over the years for their lack of focus on diversity and inclusion, but that negative attention seems to have spurred action. There's been a substantial decrease in engineering departments’ gender wage gap over the last three years.</p>
							<p>We see this progress in engineering departments as an encouraging sign that awareness and dialogue can spur real, positive change. <a class="super" href="https://twitter.com/share?text=%22We%20see%20this%20progress%20in%20engineering%20departments%20as%20an%20encouraging%20sign%20that%20awareness%20and%20dialogue%20can%20spur%20real%2C%20positive%20change.%22%20%40ChartHop%C2%A0&amp;url=https://charthop.com/charting-better-workplaces/2020/&amp;hashtags=ChartingBetterWorkplaces" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img></a></p>	
						</div>
					</div>

					<div className="row align-items-center">
						<div className="col-md-6 col-12 pr-md-2 mb-md-0 mb-3">
							<div className="graphBox">
								<h4 className="graphicHeading">BASE SALARIES IN SALES VS. ENGINEERING ROLES</h4>
								<img src={'/data-report/graph-8.svg'} alt="graph-8"></img>
							</div>
						</div>
						<div className="col-md-6 col-12 pl-md-2">
							<h4 className="leftBoxTitle">On the other hand, sales teams still have a lot of work to do in closing pay gaps along gender lines.</h4>
							<p>We found that, when excluding employees in management positions, men in sales earn <span className="blueBold">22%</span> more in base salary at $91,110. While seniority and experience contribute to this gap, even entry-level roles see a gap of<span className="blueBold"> 9%</span>.</p>
							<p>The current gap is also reflected in the share of compensation:
								 <ul>
									 <li className="mt-1">Women make up <span className="blueBold">33%</span> of the sales team, </li>
									 <li className="pb-0">Women only take home <span className="blueBold">29%</span> of the sales team’s base compensation.</li> 
								 </ul>
								</p>
							<p>These figures are even more surprising when considering that women make up a larger percentage of sales teams (<span className="blueBold">33%</span>) compared to engineering teams (<span className="blueBold">21%</span>), although still less than the average across departments of <span className="blueBold">44%</span>.</p>
						</div>
					</div>
				</div> 
			</section>

			{/* CONCLUSION */}
			<section className="conclusionSection1 sectionSpacing">
				<div className="container">
					<h2 className="text-center mb-lg-4 mb-3">Conclusion</h2>
					<p className="mb-lg-3 mb-2">This data paints a picture of the issues we must address to reach the levels of fairness and equity we need. The tech industry’s diversity and wage problems aren’t going to change overnight. We must act now.<a class="super" href="https://twitter.com/share?text=%22The%20tech%20industry’s%20diversity%20and%20wage%20problems%20aren’t%20going%20to%20change%20overnight.%20We%20must%20act%20now.%22%20%40ChartHop%C2%A0&amp;url=https://charthop.com/charting-better-workplaces/2020/" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img></a></p>
					<p>Change requires action across the board -- from founders and investors to HR leaders and employees. This is our opportunity to leverage people data for good; to understand where inequalities remain so we can chart a course forward.</p>					
					<p>Progress on the road ahead will be defined by action, and the best action is informed by tangible data and trackable results.<a class="super" href="https://twitter.com/share?text=%22Progress%20on%20the%20road%20ahead%20will%20be%20defined%20by%20action%2C%20and%20the%20best%20action%20is%20informed%20by%20tangible%20data%20and%20trackable%20results.%22%20%40ChartHop%C2%A0&amp;url=https://charthop.com/charting-better-workplaces/2020/&amp;hashtags=ChartingBetterWorkplaces" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img></a></p>
				</div>
			</section>
			
			<section className="conclusionSeparator"></section>
				
			<section className="conclusionSection2 sectionSpacing">
				<div className="container">
					<div className="row checkPointsSubSection">
						<div className="col-lg-8 col-12 m-auto">
							<h4 className="leftBoxTitle">Here are some immediate steps every organization should take to address wage gaps in the workplace: <a class="super" href="https://twitter.com/share?text=Here%20are%20some%20immediate%20steps%20every%20organization%20should%20take%20to%20address%20wage%20gaps%20in%20the%20workplace👇%C2%A0&amp;url=https://charthop.com/charting-better-workplaces/2020/&amp;hashtags=ChartingBetterWorkplaces" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img></a></h4>
							<div className="checkPointsConclusion container">
								<div class="row checkPointsItem">
									<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" className="blueCheckmark"/>
									<p><span className="darkblueBold">Track employee data across multiple dimensions such as race, gender, department and title.</span><br></br>
									Organizations can no longer afford to remain in the dark or outsource the monitoring of this vital information. Armed with the right data, organizations can evaluate compensation on a regular basis and make changes before problems compound.</p>
								</div>	
								<div class="row checkPointsItem">
									<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" className="blueCheckmark"/>
									<p><span className="darkblueBold">Build guardrails around compensation and promotion reviews -- and understand the impact of proposed changes before they go into effect.</span><br></br>
									Decrease the bias that arises when proposals are left solely up to manager discretion. Provide data&#8209;driven guidelines to ensure bias is taken out of the process. Empower managers with data to understand how their proposed changes impact pay parity across the workplace, before they’re submitted for approval.</p>
								</div>
								<div class="row checkPointsItem">
									<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" className="blueCheckmark"/>
									<p><span className="darkblueBold">Make Diversity, Equity, and Inclusion (DEI) progress, figures, and initiatives available to employees and to the public.</span><br></br>
									This ensures accountability towards achieving DEI goals. Build this habit early in your company's life and use it as a driver to build a diverse team from the beginning. </p>
								</div>	
								<div class="row checkPointsItem">
									<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" className="blueCheckmark"/>
									<p><span className="darkblueBold">Build clear pathways to management for BIPOC, women, and gender Non&#8209;binary people.</span><br></br>
									This will require changing recruiting policies and building objective level structures so employees can be fairly promoted. Advancement structures must also be carefully constructed to remove bias so that all promotions are handled in the fairest manner possible.</p>
								</div>		
								<div class="row checkPointsItem">
									<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" className="blueCheckmark"/>
									<p><span className="darkblueBold">Use market rate data to inform total compensation decisions.</span><br></br>
									Rely on data to remove room for potential bias. Focus less on a candidate's current compensation and more on what the market rate is for the role they're being hired for. Think beyond the salary - equity compensation matters. </p>
								</div>	
							</div>
							<h4 className="leftBoxTitle">Let’s do this, together.</h4>
							<p>We are confident that by taking a data&#8209;driven approach, we can work together to build the workforce of tomorrow -- one defined and empowered by a diversity of background and opinions, and invigorated by a level of fairness and equity that encourages each one of us to do our best.<a class="super" href="https://twitter.com/share?text=Let%27s%20work%20together%20to%20build%20the%20workforce%20of%20tomorrow%20--%20one%20defined%20and%20empowered%20by%20a%20%23diversity%20of%20background%20and%20opinions%2C%20and%20invigorated%20by%20a%20level%20of%20fairness%20and%20equity%20that%20encourages%20us%20to%20do%20our%20best%20👏%0D%0A%23ChartingBetterWorkplaces%20%%40ChartHop%C2%A0&amp;url=https://charthop.com/charting-better-workplaces/2020/" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img></a></p>		
						</div>
					</div>	
					<div className="row">
						<div className="row methodologyBox">
							<div className="methodologyBullet col-md-3 col-12"> 
								<h4>Methodology</h4>
							</div>
							<div className="methodologyText col-md-9 col-12">
								<p>The <span className="blue">Charting Better Wages</span> report is based on proprietary data, anonymized from a subset of ChartHop’s customers. The base pay, total compensation, distribution of equity, genders, ethnicities, titles and departments included in the report reflect data from more than 16,000 employees within the tech industry. To determine the average wage gap, we calculated how much more the higher earner makes than the lower earner. We used anecdotal evidence in instances where data sets were not significant enough to measure, such as with Non&#8209;binary data.
								</p>
							</div>							
						</div>
					</div>
				</div>
			</section>			

			{/* GET REPORT BOX */}
			<section className="getReport-box sectionSpacing">				
				<div class="container" id="getReport">
					<div class="row">
						<div class="col-md-6 col-12">
							<p class="getReport--main--text">Download the full report</p>
							<p class="getReport--secondary--text">and get more insights as they become available.</p>
						</div>
						<div class="col-md-6 col-12">							
							<DemoFormShortPDF CBW pdfUrl={'/data-report/ChartHop-Compensation-Data-Report-2020.pdf'} source={"resources-charting-better-workplaces-2020-PDF-contentdownload-box3"}/>
						</div>
					</div> 
				</div>				
			</section>

			{/* REQUEST DEMO */}
			<section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
				<DemoFormLong source={"resources-charting-better-workplaces-demo-bottom"} headertext={HtmlParser("<h2>Start tracking your own DEI data.</br> </br><b>We can help.</b></h2>")}/>
			</section>
		</Layout>
	);
};

export default Home;